const Util = {
  getJobCategoryListRaw() {
    let category = process.env.REACT_APP_JOB_CATEGORY;

    return category.split("|");
  },

  getJobCategoryList() {
    let rawCategory = Util.getJobCategoryListRaw();

    return rawCategory.map((cat) => {
      return cat.split("**")[0];
    });
  },

  getJobCategoryListWithIcon() {
    let rawCategory = Util.getJobCategoryListRaw();
    let newCategory = [];

    rawCategory.forEach((cat) => {
      const catArr = cat.split("**");
      newCategory.push({
        name: catArr[0],
        icon: catArr[1],
      });
    });

    return newCategory;
  },

  transformCategoryToGroup(numGroup) {
    let cat = Util.getJobCategoryList();
    let newCat = [];
    let perGroup = Math.ceil(cat.length / numGroup);
    let difference = cat;

    if (numGroup < 2) {
      return [cat];
    }

    for (let i = 0; i < numGroup; i++) {
      let innerCat = [];
      for (let c of difference) {
        if (innerCat.length < perGroup) {
          innerCat.push(c);
        }
        difference = difference.filter((x) => !innerCat.includes(x));
      }
      newCat.push(innerCat);
    }
    return newCat;
  },
};

export default Util;
